export const currentDate = new Date();

export const currentYear = currentDate.getFullYear().toString();

export const fileNameGenerator = (name: string) => {
  if (name) {
    const slug = name.toLowerCase().replace(/\s+/g, '-');
    return slug.slice(0, 20);
  }
  return 'filename';
};

export const birthYearValidation = (birthYear?: string) => {
  const maxValidBirthYear = currentDate.getFullYear() - 18;
  return {
    isValidBirthYear: Number(birthYear) >= 1920 && Number(birthYear) <= maxValidBirthYear,
    maxValidBirthYear: maxValidBirthYear.toString(),
  };
};
